<template>
	<div class="post-title">
		<router-link :to="{ name: 'view-post', params: { group: rowData.group.slug, post: rowData.slug }}">
			<img :src="rowData.featured_image" width="40" v-if="rowData.featured_image">
		</router-link>

        <router-link :to="{ name: 'view-post', params: { group: rowData.group.slug, post: rowData.slug }}">
        	{{ rowData.title }}
        </router-link>
	</div>
</template>

<script>
	export default {
		name: 'ColumnPostTitle',
		props: {
			rowData: {
				type: Object,
				required: true
			},
			rowIndex: {
				type: Number
			}
		},
		data () {
            return {}
        },
	}
</script>

<style lang="scss">
	.post-title{
		display: flex;
    	align-items: center;

    	img{
    		margin-right: 10px;
    		border-radius: 2px;
    	}

		a{
			color: #546b81;
			font-size: 14px;
			text-decoration: none;

			&:hover{
				text-decoration: underline;
			}
		}
	}
</style>